export const parseNumber = (
  number: string | null,
  defaultValue: number | undefined = undefined
) => {
  if (number?.length) {
    const parsed = parseInt(number)
    return parsed && !isNaN(parsed) ? parsed : defaultValue
  }
  return defaultValue
}
